import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=4acf3eca&scoped=true"
import script from "./budget.vue?vue&type=script&lang=js"
export * from "./budget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acf3eca",
  null
  
)

export default component.exports